export default __webpack_public_path__ + "static/media/15.ebd9835d.txt";